import { createFileRoute } from '@tanstack/react-router';
import { PermissionsClient } from '@/features/permissions/PermissionsClient';

// Beheer › Rechten — admin only (the path guard in @/lib/access, the API in
// rolePermissions.router.ts).
export const Route = createFileRoute('/_shell/permissions')({
  component: PermissionsClient,
});
